<template>
  <el-dialog
    title="完善用户信息"
    :visible.sync="dialogVisible"
    width="480px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="profile-form">
      <!-- 头像上传 -->
      <div class="avatar-section">
        <div class="avatar-label">头像</div>
        <div class="avatar-wrapper">
          <el-upload
            class="avatar-uploader"
            :action="`${baseURL}/common/uploadFile`"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            accept="image/*"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="formData.avatar" :src="formData.avatar" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="avatar-tip">点击上传头像</div>
        </div>
      </div>

      <!-- 昵称输入 -->
      <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
        <el-form-item label="昵称" prop="nickname">
          <el-input
            v-model="formData.nickname"
            placeholder="请输入昵称"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getBaseUrl } from '@/config'
export default {
  name: 'PerfectInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 初始数据
    nickname: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      baseURL: getBaseUrl(),
      formData: {
        nickname: '',
        avatar: ''
      },
      rules: {
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 2, max: 20, message: '昵称长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.formData.nickname = this.nickname
        this.formData.avatar = this.avatar
      }
    }
  },
  methods: {
    // 头像上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.formData.avatar = res.url
        this.$message.success('头像上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      const isImage = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'].includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件（支持 jpg、png、gif 格式）!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    // 自定义上传方法
    uploadImage(option) {
      const formData = new FormData()
      formData.append('file', option.file)
      this.$Api.uploadImage(formData).then(res => {
        if (res.code === 200) {
          this.formData.avatar = res.data.url
          this.$message.success('头像上传成功')
        } else {
          this.$message.error(res.msg || '上传失败')
        }
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true
          // TODO: 调用保存用户信息的 API
          this.$emit('submit', {
            nickname: this.formData.nickname,
            avatar: this.formData.avatar
          })
          // 模拟接口调用
          setTimeout(() => {
            this.submitting = false
            this.$message.success('保存成功')
            this.handleClose()
          }, 500)
        }
      })
    },
    // 关闭弹框
    handleClose() {
      this.$refs.form.resetFields()
      this.formData.avatar = ''
      this.dialogVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.profile-form {
  padding: 20px 40px;
}

.avatar-section {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}

.avatar-label {
  width: 80px;
  padding-right: 12px;
  font-size: 14px;
  color: #606266;
  text-align: right;
}

.avatar-wrapper {
  flex: 1;
}

.avatar-uploader {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 6px;
}

.avatar-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
